import React from 'react'
import { Link } from 'gatsby'
import { scroll_top } from '../lib/window'
import { API_HOST } from '../lib/xhr'
import { color_lookup } from '../lib/theme'

let LottiePlayer = (async () => {
  if (typeof window !== 'undefined') {
    await import("@lottiefiles/lottie-player")
  }
})()

const image_style = { height: 'auto', width: 360 }

const Player = ({ lottiefile, lottiefiles }) => {
  let source = lottiefile

  if (lottiefiles !== undefined) {
    source = lottiefiles.find(({ node }) => {
      const path = lottiefile.split('/')
      const filename = path.slice(path.length - 1, path.length)[0]
      return filename === node.relativePath
    }).node.publicURL
  }

  return (
    <lottie-player 
      src={source}
      background="transparent"
      speed="1"
      style={image_style}
      loop
      autoplay>
    </lottie-player>
  )
}

export const CenterPanel = ({ color, body, images }) => {
  const txt_cls = color && color === "azul" ? "text-white" : "text-black"
  const bg_cls = color ? txt_cls + color_lookup(color) : txt_cls

  return (
    <div className={bg_cls} style={images.length ? { background: `url('${API_HOST}${images[0].url}')`, backgroundPosition: 'center', backgroundSize: 'cover' } : null}>
      <div className="flex container pt-24 pb-64">
        <div className="w-full flex-grow">
          <div className="font-light text-center text-2xl lg:text-4xl px-4 lg:px-0">
            {body.split("\n").map((s, key) => {
              if (key === 0) {
                return <div key={'rtf-' + key} className={(bg_cls === 'text-white bg-azul' ? 'text-white' : 'text-darkazul') + ' pb-8'}>{s}</div>
              }
              return <span key={'rtf-' + key}>{s}<br /></span>
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export const SidePanel = ({ TextAlign, color, body, images, enquire, lottiefile, lottiefiles }) => {
  const flex_cls = TextAlign && TextAlign === 'right' ? "container flex items-center flex-wrap flex-row-reverse py-10" : "container flex items-center flex-wrap py-10"
  const txt_cls = color && color === "azul" ? "text-white" : "text-black"
  const bg_cls = color ? txt_cls + color_lookup(color) : txt_cls

  return (
    <div className={bg_cls}>
      <div className={flex_cls}>
        <div className="w-full md:w-1/2">
          <div className="py-10 font-light text-center text-2xl lg:text-4xl px-4 lg:px-0">
            {body.split("\n").map((s, key) => {
              if (key === 0) {
                return <div key={'rtf-' + key} className={(bg_cls === 'text-white bg-azul' ? 'text-white' : 'text-darkazul') + ' pb-8'}>{s}</div>
              }
              return <div key={'rtf-' + key}>{s}</div>
            })}
          </div>
          {
            enquire ?
            <div className="flex justify-center">
              <Link className="btn btn-primary" to="/contact" onClick={scroll_top}>Enquire Now</Link>
            </div>
            : null
          }
        </div>
        <div className="flex w-full md:w-1/2 justify-center">
          {lottiefile ? <Player lottiefile={lottiefile} lottiefiles={lottiefiles} /> : images !== undefined ? <img style={image_style} src={API_HOST + images[0].url}  alt={images[0].name} /> : null}
        </div>
      </div>
    </div>
  )
}

export const map_panel = (panel, key) => {
  if (panel.TextAlign === 'center') {
    return (
      <CenterPanel key={key} {...panel} />
    )
  }

  return (
    <SidePanel key={key} {...panel} enquire={[8].includes(panel.id)} />
  )
}
